/**
 * Admin contact-requests inbox — mirrors the Prisma `ContactRequest` model
 * (platform-level lead capture, no `tenantId`) as returned by the
 * `contact-requests-api` admin routes (`GET contact-requests`,
 * `GET contact-requests/:id`), gated on the platform-admin
 * `read:contact-requests` permission.
 *
 * SECURITY: `name`, `phone`, `message`, and `metadata` are unsanitized,
 * anonymous visitor input (see the backend DTO's SECURITY note). Any view
 * that renders them MUST rely on framework auto-escaping (Angular
 * interpolation) — never `innerHTML` / `bypassSecurityTrust`.
 */

export enum ContactRequestTypeEnum {
  ONSITE = 'ONSITE',
  GENERAL = 'GENERAL',
  PARTNER = 'PARTNER',
}

export interface ContactRequestI {
  id: string;
  type: ContactRequestTypeEnum;
  name: string;
  email: string;
  phone?: string | null;
  message?: string | null;
  metadata?: Record<string, unknown> | null;
  createdAt: string;
}

/** Paginated admin inbox page — matches the backend's skip/take contract. */
export interface ContactRequestListResultI {
  items: ContactRequestI[];
  total: number;
}

/** Query params for the admin inbox list call. */
export interface ContactRequestListQueryI {
  skip?: number;
  take?: number;
  type?: ContactRequestTypeEnum;
}
